import { createSlice } from "@reduxjs/toolkit";

const intialState={
    feeds:[],
    totalPage:0,
    count:1
}

const userFeedsSlice=createSlice({
    name:"friendFeeds",
    initialState:intialState,
    reducers:{
        setFriendFeedStateData:(state,action)=>{
            state[`${action.payload.key}`]=action.payload.value
        }
    }
})

export const {setFriendFeedStateData}=userFeedsSlice.actions

export default userFeedsSlice.reducer